import {
  jb_button_tertiary_css_default
} from "./chunk.PEHF625E.js";
import {
  ae
} from "./chunk.6PQ7B7BC.js";
import {
  Linkable
} from "./chunk.MFPI4EPN.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  ButtonElement
} from "./chunk.DIUVUHDO.js";
import {
  D,
  Oe,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-button-tertiary/jb-button-tertiary.ts
var JbButtonTertiary = class extends Initiable(ButtonElement(Linkable(r))) {
  constructor() {
    super(...arguments);
    this._arrowIcon = Oe`<svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" fill="none" aria-hidden="true"><g fill="currentColor" clip-path="url(#a)"><path fill-rule="evenodd" d="M16.961 8.555a.71.71 0 0 1 0 1.003l-4.654 4.654a.71.71 0 1 1-1.003-1.003l4.153-4.152-4.153-4.152a.71.71 0 1 1 1.003-1.003l4.654 4.653Z" clip-rule="evenodd"/><path d="M1.149 8.3h15v1.5h-15z"/></g><defs><clipPath id="a"><path fill="#fff" d="M1.149 3h16v12h-16z"/></clipPath></defs></svg>`;
  }
  render() {
    const classes = {
      inactive: !!this.inactive,
      inverted: !!this.inverted,
      hover: !!this.forceHover,
      [`${this.arrowDirection}`]: !!this.arrowDirection
    };
    return this.link?.href ? ke`<a
          data-linkable
          class=${Rt(classes)}
        >
          <slot>${this.text ? ae(this.text) : D}</slot> ${this._arrowIcon}
        </a>` : ke`<button
          ?disabled=${this.inactive}
          class=${Rt(classes)}
        >
          <slot>${this.text ? ae(this.text) : D}</slot> ${this._arrowIcon}
        </button>`;
  }
};
JbButtonTertiary.styles = [reset_css_default, jb_button_tertiary_css_default];
JbButtonTertiary.shadowRootOptions = { ...r.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n()
], JbButtonTertiary.prototype, "arrowDirection", 2);
__decorateClass([
  n({ type: Boolean })
], JbButtonTertiary.prototype, "forceHover", 2);
__decorateClass([
  n({ type: Boolean })
], JbButtonTertiary.prototype, "inactive", 2);
__decorateClass([
  n({ type: Boolean })
], JbButtonTertiary.prototype, "inverted", 2);
__decorateClass([
  n()
], JbButtonTertiary.prototype, "name", 2);
__decorateClass([
  n()
], JbButtonTertiary.prototype, "text", 2);
JbButtonTertiary = __decorateClass([
  customElement("jb-button-tertiary")
], JbButtonTertiary);

export {
  JbButtonTertiary
};
